import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Card from "./Card";
import { IRobot } from "../store/robot/types";

export interface ICardListProps {
  robots: Array<IRobot>;
}

const CardList: React.FC<ICardListProps> = ({ robots }): React.ReactElement => (
  <Fragment>
    {robots.map((robot: IRobot) => (
      <Card key={robot.id} robot={robot} />
    ))}
  </Fragment>
);

CardList.propTypes = {
  robots: PropTypes.array.isRequired,
};

export default CardList;
